import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ClearIcon from "@material-ui/icons/Clear";
import { IconButton } from "@material-ui/core";


const CssTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 0,
    },
    '& .MuiInputLabel-formControl': {
      top:'-2px'
    },
    '& label.Mui-focused': {
      color: '#9c9595',
    },
    '& .MuiInput-underline:after': {
      borderColor: '#9c9595',
      borderRadius: '0'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#9c9595',
        borderRadius: '0'
      },
      '&:hover fieldset': {
        borderColor: '#9c9595',
        borderRadius: '0',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#9c9595',
        borderRadius: '0'
      },
      height: '30px',
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    marginRight: '6px',
    marginBottom: '10px'
  },
}));

export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <>
      <CssTextField
        className={classes.margin}
        label={props.label}
        variant={props.variant}
        id={props.id}
        size={props.size}
        name={props.name}
        autoFocus={false}
        inputProps={{
          maxLength: props.maxLength,
          pattern: props.pattern,
          disabled: props.disabled
        }}

        InputProps= {props.noClear ? {} : { 
          endAdornment: (
            <IconButton style={{ background: 'transparent' }} onClick={() => props.onChange({target: {name: props.name, value: null}})} disabled={props.disabled}>
              <ClearIcon/>
            </IconButton>
          )
        }}
        InputLabelProps={{ 
          shrink: true
        }}
        {...props}
        // type="date"
        type= {(props.time==='S') ? "datetime-local" : "date"}
      />
    </>
  );
}